import React from 'react';
import './App.css';
import SEO from './components/SEO/SEO';
import Header from './components/Header/Header';
import Home from './pages/Home/Home';

function App() {
  return (
    <div className="App">
      <a href="#hero" className="skip-to-main">Skip to main content</a>
      <SEO />
      <Header />
      <main id="main-content" role="main">
        <Home />
      </main>
      <a href="https://wa.me/918826360188" target="_blank" rel="noopener noreferrer" className="whatsapp-sticky-chat" aria-label="Chat on WhatsApp">
        <span>💬</span>
      </a>
    </div>
  );
}

export default App;
